import { DataSourceSetupComposite, enumATSModes } from "./DataSourceSetupComposite";
import React from "react";
import { kCornerstoneAdditionalHeaders } from "@coreapp/constants";

export const CornerstoneSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const cornerstoneAdditionalFields = kCornerstoneAdditionalHeaders.map(cornerstoneHeader => {
    return {
      value: { headerName: cornerstoneHeader.alias, headerLabel: cornerstoneHeader.name },
      label: cornerstoneHeader.name
    };
  });

  const selectedAdditionalFields = config.additionalfields ?? [];

  const onAdditionalFieldToggle = e => {
    let option = e.value;
    let newHeader = option?.value;
    if (!newHeader) return;
    let additionalFields = config.additionalfields ?? [];
    var currentIndex = additionalFields.findIndex(
      sourceItem => JSON.stringify(sourceItem) === JSON.stringify(newHeader)
    );
    if (currentIndex > -1) additionalFields.splice(currentIndex, 1);
    else additionalFields.push(newHeader);
    onChange({ ...config, additionalfields: additionalFields });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      additionalFieldOptions={cornerstoneAdditionalFields}
      selectedAdditionalFields={selectedAdditionalFields}
      onAdditionalFieldChange={onAdditionalFieldToggle}
      showInputControls
      showAdditionalFields
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
      showAuth={false}
      ATSType={enumATSModes.toggleATS}
    />
  );
};
